const QUICK = [
  { href: "#overview", label: "全程导读" },
  { href: "#timeline", label: "事件时间线" },
  { href: "#finale", label: "大结局复盘" },
  { href: "#moments", label: "名场面" },
  { href: "#guide", label: "补课指南" },
];

const TOPICS = [
  { href: "#faq", label: "常见问题" },
  { href: "#topics", label: "收尾讨论" },
  { href: "#about", label: "关于我们" },
  { href: "#guide", label: "观看顺序" },
];

const TAGS = ["起因", "经过", "高潮", "转折", "大结局", "收尾"];

export default function Footer() {
  return (
    <footer className="bg-background-200 text-foreground-900">
      <div className="page-shell grid grid-cols-1 gap-10 py-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <a href="#top" className="inline-flex items-center gap-2" aria-label="88吃瓜复盘 回到顶部">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
              <i className="ri-goblet-fill" aria-hidden="true" />
            </span>
            <span className="font-display text-2xl text-foreground-950">
              88<span className="text-primary-500">吃瓜</span>
            </span>
          </a>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-800">
            一个专注把热门话题「复盘说清楚」的内容站。起因、经过、高潮、大结局到收尾讨论，帮你把散落的碎片拼成完整的一条线。
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {TAGS.map((t) => (
              <a
                key={t}
                href="#timeline"
                className="chip border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                {t}
              </a>
            ))}
          </div>
        </div>

        <nav className="md:col-span-3" aria-label="快速导航">
          <h4 className="text-sm font-black text-foreground-950">快速导航</h4>
          <ul className="mt-4 space-y-2.5">
            {QUICK.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-foreground-800 transition-colors hover:text-primary-600">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="md:col-span-2" aria-label="浏览指引">
          <h4 className="text-sm font-black text-foreground-950">浏览指引</h4>
          <ul className="mt-4 space-y-2.5">
            {TOPICS.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-foreground-800 transition-colors hover:text-primary-600">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="md:col-span-2">
          <h4 className="text-sm font-black text-foreground-950">联系我们</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-foreground-800">
            <li>
              <a
                href="mailto:editor@88chigua.example"
                className="inline-flex items-center gap-2 transition-colors hover:text-primary-600"
              >
                <i className="ri-mail-line text-primary-500" aria-hidden="true" />
                editor@88chigua.example
              </a>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-global-line text-primary-500" aria-hidden="true" />
              简体中文
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-primary-500" aria-hidden="true" />
              内容持续更新中
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-300">
        <div className="page-shell flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-700 sm:flex-row">
          <p>© 2026 88吃瓜 复盘站 · 内容整理自公开信息与网友讨论，仅供娱乐参考。</p>
          <p>愿你理性吃瓜，快乐追更。</p>
        </div>
      </div>
    </footer>
  );
}